/* eslint-disable react/no-array-index-key */
import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';

const { FlexPane, SkeletonPart } = MojitoPresentation.Components;

const OpenBetsSkeleton = props => {
    const {
        mojitoTools: { config },
    } = props;

    return (
        <FlexPane config={config.container} class="ta-OpenBetsSkeleton">
            {config.showTabs && (
                <FlexPane config={config.tabsContainer}>
                    <SkeletonPart config={config.tabLabel} />
                    <SkeletonPart config={config.tabLabel} />
                </FlexPane>
            )}
            {range(config.numberOfBets).map((_, index) => (
                <FlexPane key={index} config={config.betContainer} class="ta-BetPlaceholder">
                    {/* NOSONAR - The array index is used as a simple placeholder key. */}
                    <Header config={config} />
                    <BetInfo config={config} />
                    <BetFundsInfo config={config} />
                </FlexPane>
            ))}
        </FlexPane>
    );
};

const Header = ({ config }) => (
    <FlexPane config={config.betHeaderContainer}>
        <FlexPane config={config.betTitleContainer}>
            <SkeletonPart config={config.betTitlePlaceholder} />
            <SkeletonPart config={config.betDatePlaceholder} />
        </FlexPane>
        <SkeletonPart config={config.betStatusPlaceholder} />
    </FlexPane>
);

const BetInfo = ({ config }) => (
    <FlexPane config={config.betInfoContainer}>
        <SkeletonPart config={config.legStatusIconPlaceholder} />
        <FlexPane config={config.labelsContainer}>
            <SkeletonPart config={config.selectionNamePlaceholder} />
            <SkeletonPart config={config.marketNamePlaceholder} />
            <SkeletonPart config={config.eventNamePlaceholder} />
            <SkeletonPart config={config.eventDatePlaceholder} />
        </FlexPane>
        <SkeletonPart config={config.oddsPlaceholder} />
    </FlexPane>
);

const BetFundsInfo = ({ config }) => (
    <FlexPane config={config.betFundsInfoContainer}>
        <FlexPane config={config.stakeInfoContainer}>
            <SkeletonPart config={config.stakeTextPlaceholder} />
            <SkeletonPart config={config.stakeValuePlaceholder} />
        </FlexPane>
        <FlexPane config={config.payoutInfoContainer}>
            <SkeletonPart config={config.payoutTextPlaceholder} />
            <SkeletonPart config={config.payoutValuePlaceholder} />
        </FlexPane>
    </FlexPane>
);

export default OpenBetsSkeleton;
